import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/pro-solid-svg-icons';

export default class UserSelect extends React.Component {
  static propTypes = {
    blankIcon: PropTypes.object,
    blankLabel: PropTypes.string,
    blankOption: PropTypes.bool,
    displayImage: PropTypes.bool,
    fixedLabel: PropTypes.string,
    users: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      imageUrl: PropTypes.string,
      name: PropTypes.string.isRequired
    })).isRequired,
    value: PropTypes.number,
    onChange: PropTypes.func
  };

  static defaultProps = {
    blankIcon: faUsers,
    blankLabel: 'All',
    blankOption: false,
    displayImage: true
  };

  state = {
    isFocused: false
  };

  formatBlankOption = () => {
    const { blankIcon, blankLabel, blankOption, displayImage } = this.props;
    if (!blankOption) return;

    return (
      <div className="user-option blank-option" key="blank-option">
        {displayImage && blankIcon &&
          <FontAwesomeIcon className="right-buffer-md" icon={blankIcon} />
        }
        {blankLabel}
      </div>
    );
  };

  formatLabel = (user, ctx) => {
    const { id, imageUrl, name } = user;
    const { displayImage } = this.props;

    if (!id) {
      if (ctx.context === 'value') return null;
      return this.formatBlankOption();
    }

    if (ctx.context !== 'value') {
      return (
        <div className="user-option" key={id}>
          {displayImage && imageUrl &&
            <img className="img-circle profile-photo right-buffer-md" src={imageUrl} />
          }
          <span>{name}</span>
        </div>
      );
    } else if (this.state.isFocused) {
      // Show muted placeholder when focused
      return (
        <span className="text-muted" key={id}>{name}</span>
      );
    } else {
      const { fixedLabel } = this.props;

      return (
        <div className="user-option" key={id}>
          {fixedLabel && <span>{fixedLabel}:</span>}
          {displayImage && imageUrl &&
          <img className="img-circle profile-photo mr-2" src={imageUrl} />
          }
          <span>{name}</span>
        </div>
      );
    }
  };

  handleMenuToggle = (isFocused) => {
    this.setState({ isFocused: isFocused });
  };

  handleSelect = (user) => {
    const { onChange } = this.props;

    if (onChange != null) {
      onChange(user && user.id);
    }
  }

  selectedUser = () => this.props.users.find(user => user.id === this.props.value);

  render() {
    const { blankOption, onChange, users, value, ...selectProps } = this.props;
    const placeholderStyle = base => ({
      ...base,
      overflow: "hidden",
      "text-overflow": "ellipsis",
      "white-space": "nowrap",
      width: "100%"
    });

    const userOptions = blankOption ? [{ id: undefined, name: '' }, ...users] : users;

    return (
      <Select
        blurInputOnSelect={true}
        formatOptionLabel={this.formatLabel}
        getOptionLabel={user => user.name}
        getOptionValue={user => user.id}
        isClearable={false}
        name='user-select-inner'
        options={userOptions}
        styles={{ placeholder: placeholderStyle }}
        value={this.selectedUser() || ""}
        onBlur={() => this.handleMenuToggle(false)}
        onChange={this.handleSelect}
        onFocus={() => this.handleMenuToggle(true)}
        {...selectProps}
      />
    );
  }
}
